class TK_DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector('details');
    this.summary = this.details.querySelector('summary');
    this.content = this.summary.nextElementSibling;
    this.breakPintMax = '(max-width: 1079px)';

    this.summary.addEventListener('click', this.toggleDetails.bind(this));
  }

  toggleDetails(event) {
    event.preventDefault(); // デフォルトの挙動を無効化

    if (this.details.hasAttribute('open')) {
      this.closeDetails();
    } else {
      this.openDetails();
    }
  }

  openDetails() {
    this.details.setAttribute('open', 'true');
    this.details.classList.add('is_open');

    const openingAnim = this.content.animate(this.openingAnimation(), this.animationSettings());
  }

  closeDetails() {
    this.details.classList.remove('is_open');

    const closingAnim = this.content.animate(this.closingAnimation(), this.animationSettings());
    closingAnim.onfinish = () => {
      this.details.removeAttribute('open');
    };
  }

  openingAnimation() {
    return [
      { height: '0px', opacity: 0 },
      { height: `${this.content.scrollHeight}px`, opacity: 1 }
    ];
  }

  closingAnimation() {
    return [
      { height: `${this.content.scrollHeight}px`, opacity: 1 },
      { height: '0px', opacity: 0 }
    ];
  }

  animationSettings() {
    return {
      duration: 300,
      easing: 'ease'
    };
  }
}

customElements.define('tk-details-disclosure', TK_DetailsDisclosure);
